import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'store-inventory',
  standalone: false,
  templateUrl: './store-inventory.component.html',
  styleUrls: [
    './store-inventory.component.scss',
    '../../../../../../../../styles/m3-defaul-material-theme.scss',
  ],
})
export class StoreInventoryComponent {
  @Input() store: any;
  @Input() merchantId: number | any;
}
